import React from 'react'
import { Route } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'

import { FONTS } from 'styles'

import { QRScanner } from './QRScanner'
import { InvoiceForm } from './InvoiceForm'
import { MenuInvoice } from './MenuInvoice'
import { CheckInvoice } from './CheckInvoice'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  button: {
    fontFamily: FONTS.GOTHAM_LIGHT,
    fontSize: '18px',
    backgroundColor: theme.palette.primary.main,
    textTransform: 'capitalize',
    height: '45px',
    borderRadius: '10px',
    width: 200,
    color: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}))

export const Invoice: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Route path="/invoice/menu" component={MenuInvoice} />
      <Route path="/invoice/check" component={CheckInvoice} />
      <Route path="/invoice/scan" component={QRScanner} />
      <Route path="/invoice/form/:userId" component={InvoiceForm} />
    </div>
  )
}
